import React from 'react'
import IconWrapper, { IconProps } from './IconWrapper'

export default function ChevronRight({ ...props }: IconProps) {
    return (
        <IconWrapper {...props}>
            <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                preserveAspectRatio="xMidYMid meet"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M6 13.3333L11.3333 7.99996L6 2.66663"
                    stroke="#fff"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </IconWrapper>
    )
}
